<template>
  <div class="counsellingStore" >
    <div class="comWidth" >
      <div id="china-map"></div>
    </div>
    <!--导航-->
    <Nav :titles="titles" :titleChild="titleChild" :navState="navState" :tipsState="tipsState"/>
  </div>
</template>

<script>
  // 主模块
  let echarts = require('echarts/lib/echarts');
  // 散点图
  require('echarts/lib/chart/scatter');
  // 散点图放大
  require('echarts/lib/chart/effectScatter');
  // 地图
  require('echarts/lib/chart/map');
  // 图例
  require('echarts/lib/component/legend');
  // 提示框
  require('echarts/lib/component/tooltip');
  // 地图geo
  require('echarts/lib/component/geo');
  // 中国地图
  require('echarts/map/js/china');

  import Nav from '@/components/Nav'
export default {
  name: 'CounsellingStore',
  components:{
     Nav
  },
  data () {
    return {
      tipsState:false,
      navState:true,
      titles: '服務門店',
      titleChild:[{name:'銷售門店',src:'ServiceStore'},{name:'咨詢服務門店',src:'CounsellingStore'}]
    }
  },
/*  mounted () {
    let chinaMap = echarts.init(document.getElementById('china-map'))
    let showLoadingDefault = {
      text: '加载中...',
      color: '#23531',
      textColor: '#fff',
      // 地图背景色
      maskColor: '#272D3A',
      zlevel: 0
    }
    chinaMap.setOption({
      backgroundColor: '#fff',
      // 标题
      title: {
        text: '中国地图闪闪发光',
        left: 'center',
        textStyle: {
          color: '#fff'
        }
      },
      tooltip : {
        trigger: "item",
        formatter: "{b}"
      },
      // 地图上圆点的提示
//      tooltip: {
//        trigger: 'item',
//        formatter: function (params) {
//          return params.name + ' : ' + params.value[2]
//        }
//      },

      // 图例按钮 点击可选择哪些不显示
      legend: {
        orient: 'vertical',
        left: 'left',
        top: 'bottom',
        data: ['地区热度', 'top5'],
        textStyle: {
          color: '#fff'
        }
      },
      // 地理坐标系组件
      geo: {
        map: 'china',
        label: {
          // true会显示城市名
          emphasis: {
            show: false
          }
        },
        itemStyle: {
          // 地图背景色
          normal: {
            areaColor: '#465471',
            borderColor: '#282F3C'
          },
          // 悬浮时
          emphasis: {
            areaColor: '#8796B4'
          }
        }
      },
      // 系列列表
      series: [
        {
          name: '地区热度',
          // 表的类型 这里是散点
          type: 'scatter',
          // 使用地理坐标系，通过 geoIndex 指定相应的地理坐标系组件
          coordinateSystem: 'geo',
          data: [],
          // 标记的大小
          symbolSize: 12,
          // 鼠标悬浮的时候在圆点上显示数值
          label: {
            normal: {
              show: false
            },
            emphasis: {
              show: false
            }
          },
          itemStyle: {
            normal: {
              color: '#ddb926'
            },
            // 鼠标悬浮的时候圆点样式变化
            emphasis: {
              borderColor: '#fff',
              borderWidth: 1
            }
          }
        },
        {
          name: 'top5',
          // 表的类型 这里是散点
          type: 'effectScatter',
          // 使用地理坐标系，通过 geoIndex 指定相应的地理坐标系组件
          coordinateSystem: 'geo',
          data: [],
          // 标记的大小
          symbolSize: 12,
          showEffectOn: 'render',
          rippleEffect: {
            brushType: 'stroke'
          },
          hoverAnimation: true,
          label: {
            normal: {
              show: false
            }
          },
          itemStyle: {
            normal: {
              color: '#f4e925',
              shadowBlur: 10,
              shadowColor: '#333'
            }
          },
          zlevel: 1
        }
      ]
    })
    chinaMap.showLoading(showLoadingDefault)
    this.$store.commit('openLoading')
//    this.$store.dispatch('fetchHeatChinaRealData', chinaMap)
    setInterval(() => {
//      this.$store.dispatch('fetchHeatChinaRealData', chinaMap)
    }, 1000)
  }*/
mounted(){
  let chinaMap = echarts.init(document.getElementById('china-map'))
  var name_title = "澳門極草咨詢服務門店";
//  var subname = '气泡是对应的参与人数\n\n需要修改的自行数据库对接实时读取数据'
  var nameColor = " rgb(55, 75, 113)";
  var name_fontFamily = '宋体';
  var name_fontSize = 25;
  var mapName = 'china';
  var data = []
  var geoCoordMap = {};
  var toolTipData = [];

  /*获取地图数据*/
  chinaMap.showLoading();
  var mapFeatures = echarts.getMap(mapName).geoJson.features;
  chinaMap.hideLoading();
  mapFeatures.forEach(function(v) {
    // 地区名称
    var name = v.properties.name;
    // 地区经纬度
    geoCoordMap[name] = v.properties.cp;
    data.push({
      name: name,
      value: Math.round(Math.random() * 100 + 10)
    })
    toolTipData.push({
      name: name,
      value: []
    })
  });
  var max = 480,
    min = 9; // todo
  var maxSize4Pin = 50,
    minSize4Pin = 20;

  var convertData = function(data) {
    var res = [];
    for (var i = 0; i < data.length; i++) {
      var geoCoord = geoCoordMap[data[i].name];
      if (geoCoord) {
        res.push({
          name: data[i].name,
          value: geoCoord.concat(data[i].value),
        });
      }
    }
    return res;
  };
  var option = {
    title: {
      text: name_title,
//      subtext: subname,
      x: 'center',
      textStyle: {
        color: nameColor,
        fontFamily: name_fontFamily,
        fontSize: name_fontSize,
      }
    },
//    tooltip : {
//      trigger: "item",
//      formatter: "{b}"
//    },
    tooltip: {
      trigger: 'item',
      formatter: function(params) {
        if (typeof(params.value)[2] == "undefined") {
          var toolTiphtml = ''
          for (var i = 0; i < toolTipData.length; i++) {
            if (params.name == toolTipData[i].name) {
              toolTiphtml += toolTipData[i].name + ':<br>'
              for (var j = 0; j < toolTipData[i].value.length; j++) {
                toolTiphtml += toolTipData[i].value[j].name + ':' + toolTipData[i].value[j].value + "<br>"
              }
            }
          }
          return toolTiphtml;
        } else {
          var toolTiphtml = ''
          for (var i = 0; i < toolTipData.length; i++) {
            if (params.name == toolTipData[i].name) {
              toolTiphtml += toolTipData[i].name + ':<br>'
              for (var j = 0; j < toolTipData[i].value.length; j++) {
                toolTiphtml += toolTipData[i].value[j].name + ':' + toolTipData[i].value[j].value + "<br>"
              }
            }
          }
          return toolTiphtml;
        }
      }
    },
    legend: {
      orient: 'vertical',
      y: 'bottom',
      x: 'right',
      data: ['credit_pm2.5'],
      textStyle: {
        color: '#fff'
      }
    },
    visualMap: {
      show: false,
      min: 0,
      max: 1000,
      left: 'left',
      top: 'bottom',
      text: ['高', '低'], // 文本，默认为数值文本
      calculable: true,
      seriesIndex: [1],
      inRange: {
        // color: ['#3B5077', '#031525'] // 蓝黑
        // color: ['#ffc0cb', '#800080'] // 红紫
        // color: ['#3C3B3F', '#605C3C'] // 黑绿
        //  color: ['#0f0c29', '#302b63', '#24243e'] // 黑紫黑
        // color: ['#23074d', '#cc5333'] // 紫红
        //   color: ['#00467F', '#A5CC82'] // 蓝绿
        // color: ['#1488CC', '#2B32B2'] // 浅蓝
        color: ['#00467F', '#A5CC82', '#ffc0cb'] // 蓝绿红
        // color: ['#00467F', '#A5CC82'] // 蓝绿
        // color: ['#00467F', '#A5CC82'] // 蓝绿
        // color: ['#00467F', '#A5CC82'] // 蓝绿

      }
    },
    /*工具按钮组*/
    toolbox: {
      show: true,
      orient: 'vertical',
      left: 'right',
      top: 'center',
      feature: {

        dataView: {
          readOnly: false
        },
        restore: {},
        saveAsImage: {}
      }
    },
    geo: {
      show: true,
      map: mapName,
      label: {
        normal: {
          show: false
        },
        emphasis: {
          show: false,
        }
      },
      roam: true,
      itemStyle: {
        normal: {
          areaColor: '#031525',
          borderColor: '#097bba',
        },
        emphasis: {
          areaColor: '#2B91B7',
        }
      }
    },
    series: [{
      name: '散点',
      type: 'scatter',
      coordinateSystem: 'geo',
      data: convertData(data),
//      symbolSize: function(val) {
//        return val[2] / 10;
//      },
      label: {
        normal: {
          formatter: '{b}',
          position: 'right',
          show: true
        },
        emphasis: {
          show: true
        }
      },
      itemStyle: {
        normal: {
          color: '#05C3F9'
        }
      }
    },
      {
        type: 'map',
        map: mapName,
        geoIndex: 0,
        aspectScale: 0.75, //长宽比
        showLegendSymbol: false, // 存在legend时显示
        label: {
          normal: {
            show: true
          },
          emphasis: {
            show: false,
            textStyle: {
              color: '#fff'
            }
          }
        },
        roam: true,
        itemStyle: {
          normal: {
            areaColor: '#031525',
            borderColor: '#3B5077',
          },
          emphasis: {
            areaColor: '#2B91B7'
          }
        },
        animation: false,
        data: data
      },
      {
        name: '点',
        type: 'scatter',
        coordinateSystem: 'geo',
//        symbol: 'pin', //气泡
//        symbolSize: function(val) {
//          var a = (maxSize4Pin - minSize4Pin) / (max - min);
//          var b = minSize4Pin - a * min;
//          b = maxSize4Pin - a * max;
//          return a * val[2] + b;
//        },
//        label: {
//
//          normal: {
//            show: true,
//            formatter: function(params) {
//              return params.data.value[2]
//            },
//            textStyle: {
//              color: '#fff',
//              fontSize: 9,
//            }
//          }
//        },
        itemStyle: {
          normal: {
            color: '#F62157', //标志颜色
          }
        },
        zlevel: 6,
        data: convertData(data),
      },
/*      {
        name: 'Top 5',
        type: 'effectScatter',
        coordinateSystem: 'geo',
        data: convertData(data.sort(function(a, b) {
          return b.value - a.value;
        }).slice(0, 5)),
        symbolSize: function(val) {
          return val[2] / 10;
        },
        showEffectOn: 'render',
        rippleEffect: {
          brushType: 'stroke'
        },
        hoverAnimation: true,
        label: {
          normal: {
            formatter: '{b}',
            position: 'right',
            show: true
          }
        },
        itemStyle: {
          normal: {
            color: '#05C3F9',
            shadowBlur: 10,
            shadowColor: '#05C3F9'
          }
        },
        zlevel: 1
      },*/

    ]
  };
  chinaMap.setOption(option);

  window.scrollTo(0,0)
}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.counsellingStore{
  #china-map{
    width: 900px;
    height: 800px;
    margin: 0 auto;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/CounsellingStore.vue